export const storesTranslation = {
  myStore: {
    sideBarGuarderia: 'myStore.sideBar.guarderia',
    pageTitle: 'myStore.pageTitle',
    pageTitleGuarderia: "myStore.pageTitleGuarderia",
    form: {
      data: {
        title: 'myStore.form.data.title',
        name: {
          label: 'myStore.form.data.name.label',
          labelGuarderia: 'myStore.form.data.name.labelGuarderia',
          placeholder: 'myStore.form.data.name.placeholder',
          tooltip: 'myStore.form.data.name.tooltip',
        },
        afiliateCode: {
          label: 'myStore.form.data.afiliateCode.label',
          placeholder: 'myStore.form.data.afiliateCode.placeholder',
        },
        email: {
          label: 'myStore.form.data.email.label',
          placeholder: 'myStore.form.data.email.placeholder',
        },
        phone: {
          label: 'myStore.form.data.phone.label',
          placeholder: 'myStore.form.data.phone.placeholder',
          tooltip: 'myStore.form.data.phone.tooltip',
        },
        url: {
          label: 'myStore.form.data.url.label',
          placeholder: 'myStore.form.data.url.placeholder',
          tooltip: 'myStore.form.data.url.tooltip',
          legend: 'myStore.form.data.url.legend',
        },
        foodType: {
          label: 'myStore.form.data.foodType.label',
          placeholder: 'myStore.form.data.foodType.placeholder',
          tooltip: 'myStore.form.data.foodType.tooltip',
        },
        service: {
          label: 'myStore.form.data.service.label',
          physical: {
            label: 'myStore.form.data.service.physical.label',
          },
          delivery: {
            label: 'myStore.form.data.service.delivery.label',
          },
          takeAway: {
            label: 'myStore.form.data.service.takeAway.label',
          },
          noServiceError: 'myStore.form.data.service.noServiceError',
        },
        acceptConditions: {
          label: 'myStore.form.data.accept_conditions.label',
          link: 'myStore.form.data.accept_conditions.link',
          filename: 'myStore.form.data.accept_conditions.filename',
        },
      },
      editLabel: 'myStore.form.edit_label',
      cancelLabel: 'myStore.form.cancel_label',
      saveLabel: 'myStore.form.save_label',
      address: {
        title: 'myStore.form.address.title',
        warning: 'myStore.form.address.warning',
        warningGuarderia: 'myStore.form.address.warningGuarderia',
        street: {
          label: 'myStore.form.address.street.label',
          placeholder: 'myStore.form.address.street.placeholder',
          tooltip: 'myStore.form.address.street.tooltip',
        },
        number: {
          label: 'myStore.form.address.number.label',
          placeholder: 'myStore.form.address.number.placeholder',
        },
        additionalInfo: {
          label: 'myStore.form.address.additionalInfo.label',
          placeholder: 'myStore.form.address.additionalInfo.placeholder',
        },
        floorBlockStair: {
          label: 'myStore.form.address.floorBlockStair.label',
          guarderiaLabel: 'myStore.form.address.floorBlockStair.guarderia.label',
          placeholder: 'myStore.form.address.floorBlockStair.placeholder',
        },
        postalCode: {
          label: 'myStore.form.address.postalCode.label',
          placeholder: 'myStore.form.address.postalCode.placeholder',
        },
        city: {
          label: 'myStore.form.address.city.label',
          placeholder: 'myStore.form.address.city.placeholder',
        },
        province: {
          label: 'myStore.form.address.province.label',
          placeholder: 'myStore.form.address.province.placeholder',
        },
        noPlacesError: 'myStore.form.address.noPlacesError',
      },
    },
  },
  tpvs: {
    pageTitle: 'tpvs.pageTitle',
    introduction: 'tpvs.introduction',
    list: {
      title: 'tpvs.list.title',
      add: 'tpvs.list.add',
      noTpvs: 'tpvs.list.noTpvs',
    },
    guide: {
      description: 'tpvs.guide.description',
    },
    modal: {
      title: 'tpvs.modal.title',
      text: 'tpvs.modal.text',
      terminalId: {
        label: 'tpvs.modal.terminalId.label',
        placeholder: 'tpvs.modal.terminalId.placeholder',
      },
    },
    accessCard: {
      title: 'tpvs.accessCard.title',
      description: 'tpvs.accessCard.description',
      button: {
        label: 'tpvs.accessCard.button.label',
      },
    },
  },
  contacts: {
    pageTitle: 'contacts.pageTitle',
    desc: "contacts.desc",
    legend:"contacts.legend",
    legendEmail:"contacts.legend.email",
    table: {
      noResults: 'contacts.table.noResults',
      headers: {
        name: 'contacts.table.headers.name',
        email: 'contacts.table.headers.email',
        phone: 'contacts.table.headers.phone',
        position: 'contacts.table.headers.position',
      },
    },
    positions: {
      owner: 'contacts.positions.owner',
      manager: 'contacts.positions.manager',
      billing: 'contacts.positions.billing',
    },
  },
  stickers: {
    pageTitle: 'stickers.pageTitle',
    introduction: {
      content: 'stickers.introduction.content',
      guarderiaContent: 'stickers.introduction.guarderia.content',
      link: 'stickers.introduction.link',
      subject: 'stickers.introduction.subject',
    },
    form: {
      title1: 'stickers.form.title1',
      title2: 'stickers.form.title2',
      numberOfStickers: {
        label: 'stickers.form.numberOfStickers.label',
        placeholder: 'stickers.form.numberOfStickers.placeholder',
      },
      addressChoice1: {
        label: 'stickers.form.addressChoice1.label',
        guarderiaLabel: 'stickers.form.addressChoice1.guarderia.label',
      },
      addressChoice2: {
        label: 'stickers.form.addressChoice2.label',
      },
      addressDisclaimer: 'stickers.form.addressDisclaimer',
      addressDisclaimerLink1: 'stickers.form.addressDisclaimerLink1',
      addressGuarderiaDisclaimerLink1: 'stickers.form.addressGuarderiaDisclaimerLink1',
      addressDisclaimerLink2: 'stickers.form.addressDisclaimerLink2',
      noAddresses: 'stickers.form.noAddresses',
      noAddressesGuarderia: 'stickers.form.guarderia.noAddresses',
      noAddressesGuarderia1: 'stickers.form.guarderia.noAddresses1',
      noAddressesGuarderia2: 'stickers.form.guarderia.noAddresses2',
      noAddressesGuarderia3: 'stickers.form.guarderia.noAddresses3',
    },
    successOrder: 'stickers.successOrder',
  },
}
